import { type QConfigStructure } from '@exam-management/graphql';
import { Loading } from '@shared/components';
import { createContext, useMemo } from 'react';

import { useGetItemSetQuestionConditionsData } from '../../hooks';

import type {
  UpdateItemSetQuestionConditionsContextValue,
  UpdateItemSetQuestionConditionsProviderProps,
} from './types';

const UpdateItemSetQuestionConditionsContext = createContext<
  UpdateItemSetQuestionConditionsContextValue | undefined
>(undefined);

export default function UpdateItemSetQuestionConditionsProvider(
  props: Readonly<UpdateItemSetQuestionConditionsProviderProps>,
) {
  const { rowData, children } = props;

  const {
    structures,
    chapterData,
    levelItemsWithLevel,
    checkExistOnStructures,
    isLoading,
    defaultLOSRefIds,
  } = useGetItemSetQuestionConditionsData({
    chapterId: rowData.parentId,
    questionSize: rowData.size ?? 0,
    questionTypeRow: rowData,
  });

  const contextValue: UpdateItemSetQuestionConditionsContextValue = useMemo(() => {
    return {
      chapterId: rowData.parentId,
      chapterData: chapterData as QConfigStructure,
      questionTypeStructureId: rowData.id,
      levelItemsWithLevel,
      structures,
      defaultLOS: defaultLOSRefIds,
      checkExistOnStructures,
    };
  }, [
    rowData,
    chapterData,
    levelItemsWithLevel,
    structures,
    defaultLOSRefIds,
    checkExistOnStructures,
  ]);

  if (isLoading) {
    return (
      <Loading
        sx={{
          height: '100%',
          minHeight: '200px',
        }}
      />
    );
  }

  return (
    <UpdateItemSetQuestionConditionsContext.Provider value={contextValue}>
      {children}
    </UpdateItemSetQuestionConditionsContext.Provider>
  );
}

export { UpdateItemSetQuestionConditionsContext };
